import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Products from 'views/cash/closeBox/products'; // Importing Products view
import OtherExpenses from 'views/cash/closeBox/otherExpenses'; // Importing OtherExpenses view
import OtherIncome from 'views/cash/closeBox/otherIncome'; // Importing OtherIncome view
import Total from 'views/cash/closeBox/total'; // Importing Total view
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the activateRegistrationView.
 * @extends JetView
 */
export default class activateRegistrationView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        if (profile.CloseCashBox) {
            // Check if cash box should be closed
            this.show('/top'); // Navigate to the top view
        }
        const products = {
            // Configuration for Products section
            css: 'int-left',
            rows: [Products],
        };
        const otherExpenses = {
            // Configuration for Other Expenses section
            css: 'int-left',
            rows: [OtherExpenses],
        };
        const otherIncome = {
            // Configuration for Other Income section
            css: 'int-left',
            rows: [OtherIncome],
        };
        const total = {
            // Configuration for Total section
            css: 'int-left',
            rows: [Total],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        const upper_section = {
            // Main upper section layout
            id: 'b5',
            rows: [
                {
                    collapsed: true,
                    multi: true,
                    view: 'accordion', // Accordion view for collapsible sections
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    height: 1000,
                    scroll: true,
                    cols: [
                        {
                            rows: [
                                {
                                    collapsed: true,
                                    multi: true,
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    responsive: 'b5',
                                    height: 300,
                                    cols: [
                                        {
                                            id: '9',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: 'Productos', // Header for Products section
                                                    body: {
                                                        rows: [products],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    collapsed: true,
                                    multi: true,
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    responsive: 'b5',
                                    height: 300,
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: 'Otros Egresos', // Header for Other Expenses section
                                                    body: {
                                                        rows: [otherExpenses],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    collapsed: true,
                                    multi: true,
                                    view: 'accordion',
                                    css: 'betShop',
                                    margin: 15,
                                    responsive: 'b5',
                                    height: 300,
                                    cols: [
                                        {
                                            id: '10',
                                            multi: true,
                                            view: 'accordion',
                                            css: 'betShop',
                                            collapsed: false,
                                            paddingY: 10,
                                            type: 'clean',
                                            rows: [
                                                {
                                                    header: 'Otros Ingresos', // Header for Other Income section
                                                    body: {
                                                        rows: [otherIncome],
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            collapsed: true,
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            margin: 15,
                            responsive: 'b5',
                            width: 250,
                            cols: [
                                {
                                    id: '9',
                                    multi: true,
                                    view: 'accordion',
                                    css: 'betShop',
                                    collapsed: false,
                                    paddingY: 10,
                                    type: 'clean',
                                    rows: [
                                        {
                                            header: 'Total', // Header for Total section
                                            body: {
                                                rows: [total],
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    height: 'auto',
                    responsive: 'a5',
                    type: 'wide',
                    cols: [upper_section], // Include the upper section in the layout
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Check screen width
                $$('res2').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
